/**
 * Created by shubham on 11/4/18.
 */

/**
 * A model for an individual corporate employee
 */
export class FileUploadListDashboard {

    id:number;
    type: string;
    countryName: string;
    businessUnitName: string;
    includesHeader: boolean;
    csvName: string;
    csvUrl: string;
    status: string;
    error: boolean;
    message: string;
    uploadBy: string;
    uploadedAt: string;

    constructor(id:number, type:string, countryName:string, businessUnitName:string, includesHeader:boolean, csvName:string,
                csvUrl:string, status:string, error: boolean, message: string, uploadBy: string, uploadedAt: string){
        this.id = id;
        this.type = type;
        this.countryName = countryName;
        this.businessUnitName = businessUnitName;
        this.includesHeader = includesHeader;
        this.csvName = csvName;
        this.csvUrl = csvUrl;
        this.status = status;
        this.error = error;
        this.message = message;
        this.uploadBy = uploadBy;
        this.uploadedAt = uploadedAt;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/file-upload/fileUploadList-datatable/fileUploadList-dashboard.ts